<div class="td-dynamic-checkbox-wrapper">
  <mat-checkbox [formControl]="control"
                [name]="name"
                [required]="required">
    {{label}}
  </mat-checkbox>
  <span class="mat-hint td-dynamic-element-hint">{{hint}}</span>
</div>